import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import { connect } from 'react-redux';
import Header from './layout/Header';
import AccountTourPreview from './tours/AccountPreview';
import Sidebar from './layout/Sidebar';
import * as orderActions from '../actions/order';
import * as toursActions from '../actions/tours';
import * as userActions from '../actions/user';

//Data that needs to be called before rendering the component
//This is used for server side rending via the fetchComponentDataBeforeRending() method




class Account extends Component {

    componentWillMount() {

        //console.log('ACCOUNT');
        //console.log(this.props.user.id);
        //console.log(this.props.user.orders);
        //console.log(this.props.user.fetchOrders);

        if (this.props.user.id && !this.props.user.fetchOrders) {
            this.props.userActions.fetchOrders();
        }

    }


    componentWillUpdate () {
        let userActions = this.props.userActions;
        if (this.props.user.id && !this.props.user.orders && !this.props.user.fetchOrders) {
            this.props.userActions.fetchOrders();

        } else if (this.props.user.orders) {
            this.props.user.orders.forEach(function(order, index){
                if (order.departures && order.departures.length && !order.program && !order.tourFetching) {
                    userActions.fetchTour(order.departures[0].program_id, index);
                }
            });
        }
    }



    getOrders() {
        this.props.userActions.fetchOrders();
    }

    render () {
        let orders = this.props.user.orders;
        let user = this.props.user;


        return (
            <section className="section section__page ">
                <Header />
                <div className="container page">
                    <div className="container__content">
                        <div className="account">
                            <div className="account__photo"></div>
                            <div className="account__info">
                                <div className="account__name">
                                    имя пользователя
                                    <button className="account__button" onClick={this.getOrders.bind(this)}>Редактировать</button>
                                </div>
                                <div className="account__country">Англия, Лондон</div>
                                <div className="account__row">
                                    <label className="account__label">Email: </label> {user.email}
                                </div>
                                <div className="account__row">
                                    <label className="account__label">Телефон: </label> 8 985 834-32-59
                                </div>
                            </div>
                        </div>
                        {(orders && !!orders.length) &&
                            <div>
                                {orders.map((order, i)=>
                                    <AccountTourPreview tour={(order.program?order.program:{})} order={order} departure={order.departures[0]} toursActions={this.props.toursActions} userActions={this.props.userActions}></AccountTourPreview>
                                )}
                            </div>
                        }
                    </div>
                    <Sidebar />
                </div>
            </section>



        );
    }
}




function mapStateToProps(state) {
    //console.log(state);

    return {
        tours: state.tours,
        user: state.user,
        order: state.order
    };
}

function mapDispatchToProps(dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch),
        orderActions: bindActionCreators(orderActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Account);


// WEBPACK FOOTER //
// ./src/common/components/Account.js